import { BellAlertIcon } from "@heroicons/react/24/outline";
import { useWorkspaceAttention } from "@via/pages/agent-workspaces/workspaces.api.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { type JSX } from "react";
import { Link } from "react-router-dom";

/**
 * Header badge for chain steps that need their owner (workspace job chains, spec D8): a held step
 * awaiting review, a step the cluster refused, a skipped step not yet seen. Hidden at zero and while
 * the installation keeps chains off. One workspace links to it, several to the workspace list.
 * Renders its own list item, so it sits among the header's other items.
 */
export function WorkspaceAttentionBadge(): JSX.Element | null {
  const { data } = useWorkspaceAttention();
  if (!data || data.total <= 0) return null;

  const [only] = data.workspaces;
  const to =
    data.workspaces.length === 1
      ? `${ROUTES.WORKSPACES}/${only.workspaceId}`
      : ROUTES.WORKSPACES;
  const label = `${data.total} workspace ${data.total === 1 ? "step needs" : "steps need"} your attention`;

  return (
    <li className="relative flex items-center">
      <Link
        to={to}
        data-testid="workspace-attention-badge"
        aria-label={label}
        title={label}
        className="relative inline-flex items-center text-amber-600 duration-150 ease-in-out hover:text-amber-500">
        <BellAlertIcon className="h-5 w-5" aria-hidden="true" />
        <span className="ml-1 rounded-full bg-amber-100 px-1.5 text-[11px] font-semibold leading-4 text-amber-800">
          {data.total}
        </span>
      </Link>
    </li>
  );
}
